module.exports = __webpack_public_path__ + "img/Celery.05b5a83f.svg";